import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'
import { useAPIGetPelaksanaanPerilakuKerja } from 'api/kinerja/penilik-pegawai/pelaksanaan'
import { usePenilikStatus } from './useSummary'

import type { PelaksanaanPerilakuKerja } from 'types/kinerja-penilik-pegawai'

type PelaksanaanPerilakuKerjaHooks = {
  pelaksanaan: PelaksanaanPerilakuKerja
  apiStatus: string
}

export const usePelaksanaanPerilakuKerja =
  (): PelaksanaanPerilakuKerjaHooks => {
    const { isHavePeriod } = usePeriodContext()
    const { summary: penilikSummary } = usePenilikStatus({
      disabled: !isHavePeriod,
    })
    const { data: pelaksanaan, status: apiStatus } =
      useAPIGetPelaksanaanPerilakuKerja({
        skpId: penilikSummary?.skpId,
        enabled: !!penilikSummary?.skpId && isHavePeriod,
      })

    return {
      pelaksanaan,
      apiStatus,
    }
  }
